// This file has been partially auto generated. 
// Please don't make any changes to the lenses.
// Feel free to add or remove annotated properties from
// the generator data class. The corresponding lenses 
// will be removed or added on the next run of the 
// lens generator. See below for more details.
package org.solyton.solawi.bid.module.bid.data.evaluation

import org.evoleq.optics.Lensify
import org.evoleq.optics.ReadOnly
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.module.bid.data.auction.AuctionDetails

/**
 * Generator class.
 * Feel free to add or remove annotated properties from
 * the class. Make sure that they are annotated with
 * - @ReadOnly
 * - @ReadWrite
 * If you want that a property-lens will be generated
 * on the next run of the lens generator.
 * If not, just omit the annotation or annotate it with @Ignore.
 */
@Lensify data class BidRoundPreEvaluation(
    @ReadOnly val auctionDetailsPreEval: AuctionDetails = AuctionDetails(),
    @ReadOnly val totalNumberOfSharesPreEval: Int = 0
)

/**
 * Autogenerated ReadOnly Lens.
 * Read [BidRoundPreEvaluation.auctionDetails]
 */
@ReadOnly val auctionDetailsPreEval: Lens<BidRoundPreEvaluation, AuctionDetails> by lazy{ Lens(
    get = {whole -> whole.auctionDetailsPreEval},
    set = {{it}}
) }
/**
 * Autogenerated ReadOnly Lens.
 * Read [BidRoundPreEvaluation.totalNumberOfShares]
 */
@ReadOnly val totalNumberOfSharesPreEval: Lens<BidRoundPreEvaluation, Int> by lazy{ Lens(
    get = {whole -> whole.totalNumberOfSharesPreEval},
    set = {{it}}
) }
